import {
  post_request,
  get_request_export
} from '../axiosFun';

//运营日志列表
export const get_queryList_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      group_id: params.groupId,
      car_status: params.carStatus,
      place_now_id: params.carAddress,
      page_no: params.page,
      page_size: params.limit,
    }
  }
  return post_request("/web/operatingLog/queryList", params)
};
//小组下拉列表
export const get_queryGroup_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/operatingLog/queryGroup", params)
};
//车辆状态下拉列表
export const get_queryCarStatus_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/operatingLog/queryCarStatus", params)
};
//地点下拉列表
export const get_queryPlace_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectOperatingLog/cloudPlatformAreaSummaryNoParent", params)
};
//车辆下拉列表
export const get_querySelectableCar_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/operatingLog/querySelectableCar", params)
};
//添加
export const get_operate_add = (params) => {
  params = {
    row: {
      vin: params.vin,
      group_id: params.groupId,
      car_item_id: params.carStatus,
      car_specific_expression: params.carSpecificExpression,
      fault_rate: params.faultRate,
      place_now_id: params.placeNowId,
      car_route: params.carRoute,
      equip_man: params.equipMan,
      select_date: params.selectDate,
    }
  }
  return post_request("/web/operatingLog/add", params)
};
//获取单条
export const get_operate_id = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/operatingLog/queryOperatingLogById", params)
};
//编辑
export const get_operate_edit = (params) => {
  params = {
    row: {
      id: params.id,
      vin: params.vin,
      group_id: params.groupId,
      car_item_id: params.carStatus,
      car_distance_expression: params.carDistanceExpression,
      fault_rate: params.faultRate,
      place_now_id: params.placeNowId,
      car_route: params.carRoute,
      equip_man: params.equipMan,
      select_date: params.selectDate,
    }
  }
  return post_request("/web/operatingLog/updateOperatingLog", params)
};
//编辑
export const get_operate_del = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/operatingLog/deleteOperatingLog", params)
};

//导出
export const get_operate_export = (params) => {
  params = {
    row: {
      vin: params.vin,
      group_id: params.groupId,
      car_status: params.carStatus,
      place_now_id: params.carAddress,
    }
  }
  return get_request_export("/web/operatingLog/export", params)
};



// WEBPACK FOOTER //
// ./src/api/car_operate/car_operate.js